import { AccommodationRequestTableColumns } from "@bonliva-crm/shared";
import { useMemo } from "react";
import locale from "@bonliva-crm/locale";

const defaultColumns: AccommodationRequestTableColumns[] = Object.values(AccommodationRequestTableColumns);

export function useColumnNameSelector() {
  const columnNameSelector = useMemo(() => {
    return {
      localStorageName: "accommodationRequestSearchColumns",
      defaultColumns: defaultColumns.map((value) => ({
        label: locale.accommodationRequestTableColumnType[value],
        value: value
      }))
    };
  }, []);

  return columnNameSelector;
}
